import styled from 'styled-components';

import {colors, font} from 'theme';

export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 24px;
`;

export const MustFillSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 24px;
    max-width: 673px;
`;

export const SectionTitle = styled.h2`
    margin: 0;
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.32px;
    text-transform: uppercase;
`;

export const ProductCard = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    border: 0.688px solid #e2e2e2;
    background: #fff;
    padding: 16px;
`;

export const ProductIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    border-radius: 6px;
    background: ${colors.brandLight};
`;

export const ProductInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const ProductCode = styled.span`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 21px;
`;

export const ProductMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    color: ${colors.textMuted};
    font-family: ${font.family.primary};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
`;

export const AdditionalInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    width: 100%;
`;

export const InfoRow = styled.div`
    display: flex;
    gap: 16px;
    align-items: flex-start;
    width: 100%;
`;

export const InfoField = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const InfoLabel = styled.span`
    color: #90a1b9;
    font-family: ${font.family.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`;

export const InfoValue = styled.span`
    color: ${colors.textPrimary};
    background: ${colors.brandLight};
    border-radius: 6px;
    padding: 6px 10px;
    width: fit-content;
    font-family: ${font.family.primary};
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
`;

export const InfoDivider = styled.div`
    width: 100%;
    border-top: 1px solid #f1f5f9;
    padding-top: 12px;
`;
